// extracted by mini-css-extract-plugin
export default {"box":"Pagination_box__kNsIx"};